import React from "react";
import { FormControl, FormLabel, FormErrorMessage, Box, Tooltip } from "@chakra-ui/react";

import { AsyncPaginate } from "react-select-async-paginate";
import { useSelector } from "react-redux";
import { getTimezones } from "../../../../api/libs/countries";

export default function Timezones({ formik, column }) {
	const lang = useSelector(state => state.languageProvider.language);

	const loadOptions = async (searchQuery, loadedOptions, { page }) => {
		if (searchQuery && searchQuery.length < 2) {
			return null;
		}
		const response = await getTimezones(
			formik.values.timezone.zone_name || formik.values.timezone,
			page,
			formik.values.country.iso2,
		);
		if (formik.values.timezone && page === 1) {
			formik.setFieldValue("timezone", response.data[0]);
		}
		return {
			options: response.data,
			hasMore: response.next_page_url,
			additional: {
				page: searchQuery ? 2 : page + 1,
			},
		};
	};

	const onChange = option => {
		formik.setFieldValue("timezone", option);
	};

	return (
		<FormControl
			display="grid"
			gridTemplateColumns={
				column ? ["1fr", "1fr", "1fr", "1fr", "1fr"] : ["1fr", "1fr", "1fr", "2fr 8fr", "2fr 8fr"]
			}
			alignItems="center"
			isInvalid={formik.errors.timezone}
			id="timezone"
		>
			<FormLabel
				_focus={{
					color: "#1274BC",
					fontWeight: 700,
				}}
			>
				{lang === "de" ? "Timezone" : "Timezone"}
			</FormLabel>
			<Box display="flex" flexDirection="column">
				<Tooltip label={formik.errors.country} hasArrow arrowSize={15} bg="red.600">
					<AsyncPaginate
						key={JSON.stringify(formik.values.country)}
						theme={theme => ({
							...theme,
							borderRadius: 0,
						})}
						isDisabled={typeof formik.values.country !== "object"}
						value={formik.values.timezone || ""}
						loadOptions={loadOptions}
						getOptionValue={option => `${option.zone_name} ${option.gmt_offset_name}`}
						getOptionLabel={option => `${option.zone_name} ${option.gmt_offset_name}`}
						onChange={onChange}
						placeholder={
							formik.values.timezone !== ""
								? formik.values.timezone
								: formik.values.country
								? "Select Timezone"
								: "Select Country First"
						}
						additional={{
							page: 1,
						}}
					/>
				</Tooltip>
				{/* <FormErrorMessage
          position={column ? "absolute" : "relative"}
          bottom="-1.2em"
        >
          {formik.errors.timezone}
        </FormErrorMessage> */}
			</Box>
		</FormControl>
	);
}
